t = require('app/scripts/views/internal/teacup-with-helpers')('label')

module.exports = t.renderable ({ color, name, extraClasses }) ->
  classes =
    'card-label': true

  if color
    classes["card-label-#{ color }"] = true

  if extraClasses
    for c in extraClasses
      classes[c] = true

  t.span { class: t.classify(classes), title: name ? "#{ color } label (default)" }, ->
    t.span { class: 'label-text' }, ->
      if name
        t.text name
      else
        t.raw '&nbsp;'
